const DEV_TEAM_CREATE_TOURNAMENT_CALENDAR_ID = '7a9e0051-eeb5-4718-9786-fa80c0069914';
const PROD_TEAM_CREATE_TOURNAMENT_CALENDAR_ID = '93767105-f1dc-4bb0-a73c-fafb8f5f07d3';

const configuredTeamCreateTournamentCalendarId =
  import.meta.env.VITE_TEAM_CREATE_TOURNAMENT_CALENDAR_ID?.trim();
const isProductionBuild = import.meta.env.PROD || import.meta.env.MODE === 'production';

const shouldUseConfiguredTeamCreateTournamentCalendarId =
  configuredTeamCreateTournamentCalendarId &&
  !configuredTeamCreateTournamentCalendarId.includes('{{') &&
  !(
    isProductionBuild &&
    configuredTeamCreateTournamentCalendarId === DEV_TEAM_CREATE_TOURNAMENT_CALENDAR_ID
  );

export const TEAM_CREATE_TOURNAMENT_CALENDAR_ID = shouldUseConfiguredTeamCreateTournamentCalendarId
  ? configuredTeamCreateTournamentCalendarId
  : isProductionBuild
    ? PROD_TEAM_CREATE_TOURNAMENT_CALENDAR_ID
    : DEV_TEAM_CREATE_TOURNAMENT_CALENDAR_ID;
